<template>
        <div id='certification'>
              <NavTop title='我的授权书'/>
              <div class='content'>
                  <img class="bgimg" src="~@/assets/img/sqs.jpg"/>
                  <div class="username">{{uinfo.username}}</div>
                  <div class="mobile">{{uinfo.mobile}}</div>
              </div>    
        </div>
</template>
<script>
import NavTop from '@/components/navtop'
export default {
  data(){
      return{
          uinfo:{}
      }
  },  
  name: 'certification',
  created(){
     this.getList()
  },
  methods:{
     getList(){
        this.$post("/user/getUserInfo",{}).then((data)=>{
            if(data.result.success){
                this.uinfo=data.result.info
            }
        })
     }
  },
  components:{
      NavTop
  }
}
</script>
<style scoped>
#certification{background-color:#F6F6F6;min-height: 100vh;}
.content{width:100%;;overflow: hidden;position: relative;}
.bgimg{width:100%;height: 100%;}
.username{position: absolute;left:4.5rem;top:5.75rem;color: #333;font-size: 0.4rem;width:2rem;height:0.5rem;}
.mobile{position: absolute;left:3.4rem;top:6.7rem;color: #333;font-size: 0.4rem;width:2rem;height:0.5rem;}
::v-deep .fixcon{margin-bottom: 0px!important;}
</style>


